import React from 'react';
import PropTypes from 'prop-types';
import { issueWrapperArrayType } from '../../../constants/proptype-validation';

import { ENTITY_TYPES, LinkedEntitiesProvider } from '@adsk/bim360-matrix-react-components';

const LinkedEntitiesProviderFF = ({ children, issues, linkedEntitiesFF, plugins }) => {
  if (!linkedEntitiesFF) return children;

  const newest20Issues = issues.slice(0, 20);
  const issuesIds = newest20Issues.map(row => row.attributes.id);
  return (
    <LinkedEntitiesProvider 
      ids={issuesIds} 
      sourceEntityType={ENTITY_TYPES.RFI} 
      plugins={plugins} 
      autoLoadMore
    >
      {children}
    </LinkedEntitiesProvider>
  );
};
LinkedEntitiesProviderFF.propTypes = {
  children: PropTypes.node.isRequired,
  issues: issueWrapperArrayType.isRequired,
  linkedEntitiesFF: PropTypes.bool.isRequired,
  plugins: PropTypes.array.isRequired,
};

export default LinkedEntitiesProviderFF;
